import apiClient from 'services/_infra/apiClient';

export async function adminStartService(name) {
  try {
    const res = await apiClient.post(`/service-manager/admin/service/start/${name}`);
    return res.data;
  } catch (err) {
    console.error(`Admin start failed for '${name}':`, err);
    throw err;
  }
}

export async function adminStopService(name) {
  try {
    const res = await apiClient.post(`/service-manager/admin/service/stop/${name}`);
    return res.data;
  } catch (err) {
    console.error(`Admin stop failed for '${name}':`, err);
    throw err;
  }
}

// Remove Service
export async function adminRemoveService(pmId) {
  try {
    const res = await apiClient.delete(`/service-manager/admin/service/remove/${pmId}`);
    return res.data;
  } catch (err) {
    console.error(`Error removing service '${pmId}':`, err);
    throw err;
  }
}

// Add Service
export async function adminAddService(name) {
  try {
    const res = await apiClient.put(`/service-manager/admin/service/add/${name}`);
    return res.data;
  } catch (err) {
    console.error(`Error adding service '${name}':`, err);
    throw err;
  }
}
